import { object } from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Table, CardTitle } from "reactstrap"


export const expandRow  = {
  renderer: row => (

    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-3">Invoice Summary</CardTitle>

          <div className="table-responsive">
             <Table bordered hover responsive>
          <thead>
            <tr>
              <th>S#</th>
              <th>Order No</th>
              <th>Price</th>
              <th>Order Name</th>
              <th>Sent Date</th>
            </tr>
          </thead>
          <tbody>
            {row.inv.map((rec,idx) => {return (
   <tr key={idx}>
              <th scope="row">{idx + 1}</th>
              <td>{rec.orderNo}</td>
              <td>{rec.price}</td>
              <td>{rec.orderName}</td>
              <td>{rec.sentDate ? new Date(rec.sentDate).toLocaleDateString() : ""}</td>
            </tr>
            )})}
          </tbody>
        </Table>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  ),
  showExpandColumn: true,
}
